export type {
  NavSlots,
  NavBaseProps as NavProps,
  NavBaseState as NavState,
  OnNavItemSelectData,
  NavItemValue,
} from '@fluentui/react-nav';
